<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-center>
      <v-flex text-xs-center>
        <v-form ref="formSmsProvider" v-model="isValidSmsProviderForm">
          <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12 text-xs-center>
              <h1>СМС провайдер</h1>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7>
              <v-select
                v-model="sms.provider"
                :items="smsProviders"
                label="СМС агрегатор"
                autocomplete="new-password"
                required
                :rules="emptyFieldRules">
              </v-select>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7>
              <v-text-field
                v-if="sms.provider !== 'SMS.BY'"
                v-model="sms.login"
                label="Логин"
                autocomplete="new-password"
                required
                :rules="emptyFieldRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7>
              <v-text-field
                v-if="sms.provider !== 'SMS.BY'"
                v-model="sms.password"
                label="Пароль"
                type="password"
                autocomplete="new-password"
                required
                :rules="emptyFieldRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7>
              <v-text-field
                v-if="sms.provider === 'SMS.BY'"
                v-model="sms.accessToken"
                label="API токен"
                type="password"
                autocomplete="new-password"
                required
                :rules="emptyFieldRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <v-btn color="#4169E1" style="color:white" @click="connectSmsProvider()">Подключить</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    sms: {
      provider: '',
      login: '',
      password: '',
      name: '',
      accessToken: ''
    },
    smsProviders: ['RocketSMS', 'Imobis', 'SMS.BY'],
    isValidSmsProviderForm: true,

    emptyFieldRules: [
      v => !!v || 'Необходимо заполнить'
    ]
  }),

  created () {
    this.$store.commit('showNavigation')
    this.getInfo()
  },

  methods: {
    getInfo: function () {
      this.$http.get('/api/setupAuth/getInfo')
        .then(response => {
          this.sms.provider = response.data.smsProvider
          this.sms.login = response.data.smsUsername
          this.$refs.formSmsProvider.resetValidation()
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    connectSmsProvider: function () {
      if (this.$refs.formSmsProvider.validate()) {
        this.$http.post('/api/setupAuth/connectSmsProvider', this.sms)
          .then(response => {
            this.$store.dispatch('showSnackbar', {
              text: 'Настройки провайдера обновлены',
              color: 'success'
            })
          })
          .catch(error => {
            this.$store.dispatch('handleError', error.response)
          })
      }
    }
  }
}
</script>
